import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "bg-gray-stroke" }
const _hoisted_2 = { class: "container relative px-4 mx-auto text-left py-8 justify-between flex flex-col items-center lg:py-10 lg:flex-row" }
const _hoisted_3 = { class: "flex items-center flex-none w-full md:justify-start lg:w-max" }
const _hoisted_4 = { class: "font-bold text-3xl lg:text-4xl text-black mr-4 lg:mr-0" }
const _hoisted_5 = { class: "w-full flex justify-end items-center" }

import router from '@/router'

type Props = {
    title: string
    canGoBack?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: true, default: '' },
    canGoBack: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, canGoBack: boolean }


const goBackToPreviousPage = () => {
    router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_IconArrowLeftSmall = _resolveComponent("IconArrowLeftSmall")!
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.canGoBack)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex-none cursor-pointer mr-2 lg:mr-0 lg:absolute lg:-left-8",
              onClick: goBackToPreviousPage
            }, [
              _createVNode(_component_IconArrowLeftSmall, { class: "block lg:hidden" }),
              _createVNode(_component_IconArrowLeft, { class: "hidden lg:block" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(props.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})